import { useState, createContext, useCallback, forwardRef } from "react"
import { Layout } from "widgets"
import { classes } from "utils"

export const Notification = forwardRef(({ type, message }, ref) => (
  <div className='notification-container' ref={ref} css={{width:'100%'}}>
    {message && (
      <Layout
        className={classes(type, "notification")}
        css={{
          padding: 20,
          marginBottom: 40,
          background: "white",
          boxShadow: "0px 0px 6px #00000029",
          borderRadius: 6,
        }}
      >
        <Layout
          className="notification-content"
          css={{
            borderLeft: `5px solid ${type === "success" ? "green" : "red"}`,
            padding: "5px 30px",
          }}
        >
          <Layout
            className="notification-message"
            css={{
              fontSize: 20,
              fontWeight: 500,
              color: type === "success" ? "green" : "red",
            }}
          >
            {message}
          </Layout>
        </Layout>
      </Layout>
    )}
  </div>
))

Notification.displayName = "Notification"

export const useNotificationContext = ({ ref }) => {
  const [type, setType] = useState()
  const [message, setMessage] = useState("")

  const resetNotification = useCallback(() => {
    setType(null)
    setMessage("")
  }, [])

  const notifySuccess = useCallback(
    message => {
      setType("success")
      setMessage(message)
      ref.current?.scrollIntoView({
        behavior: "smooth", // Smooth scrolling
        block: "start", // Aligns the element to the top of the viewport
        inline: "nearest", // Aligns the element horizontally to the nearest edge
      })
    },
    [ref],
  )

  const notifyError = useCallback(message => {
    setType("error")
    setMessage(message)
    ref.current?.scrollIntoView({
      behavior: "smooth", // Smooth scrolling
      block: "start", // Aligns the element to the top of the viewport
      inline: "nearest", // Aligns the element horizontally to the nearest edge
    })
  }, [ref])

  return {
    type,
    message,
    notifySuccess,
    notifyError,
    resetNotification,
  }
}

export const NotificationContext = createContext({})
